export default __webpack_public_path__ + "a89216dc684549db300666e84f9f7c8a.png";